import { IExtender } from '.';
import safeJSONParse from '../../../../scripts/utils/safeJsonParse';
import { IKeyedStickers, ISticker } from '../types';


const getSettingsStickers = (): IKeyedStickers => {
  try {
    const settingsScript: HTMLElement | null = document.getElementById('stickerSettings')
    if (!settingsScript) return {}
    const raw = settingsScript.textContent
    if (!raw) return {}
    return safeJSONParse(raw, {}) as unknown as IKeyedStickers
  } catch {
    return {}
  }
}

const getStickers = (): IKeyedStickers => {
  try {
    const stickerScript: HTMLElement | null = document.getElementById('stickerData')
    if (!stickerScript) {
      return getSettingsStickers()
    }
    const stickerDataRaw = stickerScript.textContent
    if (!stickerDataRaw) {
      return getSettingsStickers()
    }
    const data = safeJSONParse(stickerDataRaw, {}) as unknown as IKeyedStickers
    const settings = getSettingsStickers()
    return { ...settings, ...data }
  } catch (error) {
    console.error('Error parsing sticker data:', error)
    return getSettingsStickers()
  }
}

const getProductStickersFromTags = (stickers : IKeyedStickers, tags: string[], totalStock: number): ISticker[] => {
  if (Object.keys(stickers).length < 1 ) return [] as ISticker[] // if no stickers
  if (!tags || tags.length < 1) return [] as ISticker[] // if no tags

  const foundStickers: ISticker[] = []

  tags.forEach(tag => {
    if (tag && typeof tag === 'string') {
      const tagLower = tag.toLowerCase().trim()
      // DIRECT MAPPING: Use the tag name directly as the key
      const stickerKey = tagLower

      console.log('Checking tag:', tag, '-> Key:', stickerKey)
      console.log('Available stickers:', Object.keys(stickers))

      // Special case: bis-tag requires stock > 200
      if (tagLower === 'bis-tag' && totalStock > 200 && stickers[stickerKey]) {
        foundStickers.push(stickers[stickerKey] as ISticker)
        return
      }

      // Special case: low-stock-tag requires stock < 20
      if (tagLower === 'low-stock-tag' && totalStock < 20 && stickers[stickerKey]) {
        foundStickers.push(stickers[stickerKey] as ISticker)
        return
      }

      // General case: check if sticker exists in configuration
      if (stickers[stickerKey]) {
        foundStickers.push(stickers[stickerKey] as ISticker)
      }
    }
  })

  return foundStickers
}

// We rely on tags provided by the search service mapping (Voyado → mapProduct.ts)

const withStickers: IExtender = {
  init: () => {
    try {
      if (!window['blubolt']) {
        window['blubolt'] = {}
      }
      window['blubolt'].stickers = getStickers()
    } catch (error) {
      console.error('Error initializing stickers:', error)
      if (!window['blubolt']) {
        window['blubolt'] = {}
      }
      window['blubolt'].stickers = {}
    }
  },
  extendGetProductsResult: (results) => {
    try {

      const updatedProducts = results.products.map(product => {
        const tags = Array.isArray(product.tags) ? product.tags.slice() : [] // Make a copy so we can modify it

        // Check if product is on sale (compare_at_price > selling price)
        const isOnSale = product.priceObj
          ? product.priceObj.originalPrice > product.priceObj.finalPrice
          : (product.compare_at_price_max || 0) > (product.price || 0)

        // If on sale and doesn't have 'sale' tag, add it automatically
        if (isOnSale && !tags.some(tag => tag.toLowerCase() === 'sale')) {
          tags.push('sale')
        }

        // Calculate total stock from variants
        const totalStock = Array.isArray(product.variants)
          ? product.variants.reduce((sum, variant) => {
            return sum + (variant.inventory_quantity || 0)
          }, 0)
          : 0


        const productStickers = getProductStickersFromTags(
          window['blubolt']?.stickers || {},
          tags,
          totalStock
        )

        const limitedStickers = productStickers.slice(0, 3)

        return {
          ...product,
          meta: {
            ...product.meta,
            stickers: limitedStickers
          }
        }
      })

      return { ...results, products: updatedProducts }
    } catch (error) {
      console.error('Error extending products with stickers:', error)
      return results
    }
  }
}

export default withStickers;